<div id="instanceFunctionDialog" 
    appDraggable dragTarget="#instanceFunctionDialogContent" dragHandle="#instanceFunctionDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle"
    style="width:auto; min-width: 450px; max-width: 100%; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
    role="dialog"
    tabindex="-1"
    >

    <div role="document" id="instanceFunctionDialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="instanceFunctionDialogHeader">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">x</span>
                </button>
                <h4 class="modal-title">
                    <span>{{ getDialogTitle() }}</span>
                </h4>
            </div>

            <div class="modal-body">
                <ng-container *ngFor="let datum of functionData">
                    <div class="row">
                        <div class="objectParam parameterLabel labelNormal col-sm-4">
                            {{ datum.functionParameter.name }}
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" [(ngModel)]="datum.value" />
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="hide()">
                    <i class="fa fa-ban"></i> CANCEL
                </button>
                <button type="button" class="btn btn-primary" (click)="execute()">
                    EXECUTE
                </button>
            </div>

        </div>
    </div>

</div>

<app-function-executing-dialog #functionExecutingDialog></app-function-executing-dialog>